module.exports = __webpack_public_path__ + "img/404-illu.101ba52a.svg";